import Typography from "@/components/typography/Typography"
import { useBreakpoint } from "@/hooks/useBreakpoint"
import { FC } from "react"
import "./AdvantageCard.less"
import autoWorkflow from "./assets/auto-workflow.webp"
import correspondence from "./assets/correspondence.webp"
import network from "./assets/network.webp"
import reducing from "./assets/reducing-shadow.webp"
import speed from "./assets/speed-shadow.webp"

const { Title, Paragraph } = Typography

export const ADVANTAGE_IMG_MAP = {
  autoWorkflow,
  correspondence,
  network,
  reducing,
  speed,
} as const

export type AdvantageImgType = keyof typeof ADVANTAGE_IMG_MAP

type Mode = "vertical" | "horizontal"

export type AdvantageCardProps = {
  image: AdvantageImgType
  title: string
  text: string
  mode: Mode
  isLast?: boolean
}

const AdvantageCard: FC<AdvantageCardProps> = ({ image, title, text, mode, isLast = false }) => {
  const { xxl, xl, lg, md, sm, xs } = useBreakpoint()

  return (
    <div
      className={`advantage-card-wrapper ${mode === "horizontal" ? "horizontal-card" : ""} ${isLast ? "is-last" : ""}`}
    >
      <div className={`advantage-img-wrapper ${mode === "horizontal" ? "horizontal-card" : ""}`}>
        <img src={image} alt={""} loading={"lazy"} decoding={"async"} />
      </div>

      <div className={"advantage-description-block"}>
        <div className={"advantage-title-box"}>
          <Title level={5} color={"white"} centered={!(xxl || xl || lg || md || sm)}>
            {title}
          </Title>
        </div>
        <Paragraph
          centered={!(xxl || xl || lg || md || sm)}
          color={"website-secondary"}
          size={xxl || xl || lg || md ? "md" : "sm"}
          style={{ paddingLeft: xxl || xl || lg || md || sm ? 16 : 0 }}
        >
          {text}
        </Paragraph>
      </div>
    </div>
  )
}

export default AdvantageCard
